var _g, _defs;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMessageAlert = function SvgMessageAlert(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.626 13.4982L11.2675 1.80957C10.2459 0.0896862 7.7555 0.087401 6.73252 1.80957L0.374304 13.4982C-0.670047 15.2556 0.594347 17.4811 2.64125 17.4811H15.3585C17.4037 17.4811 18.6704 15.2574 17.626 13.4982ZM9 15.3717C8.41858 15.3717 7.94531 14.8984 7.94531 14.317C7.94531 13.7356 8.41858 13.2623 9 13.2623C9.58141 13.2623 10.0547 13.7356 10.0547 14.317C10.0547 14.8984 9.58141 15.3717 9 15.3717ZM10.0547 11.1529C10.0547 11.7344 9.58141 12.2076 9 12.2076C8.41858 12.2076 7.94531 11.7344 7.94531 11.1529V5.8795C7.94531 5.29808 8.41858 4.82481 9 4.82481C9.58141 4.82481 10.0547 5.29808 10.0547 5.8795V11.1529Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-alert.0b7e9f8d.svg";
export { ForwardRef as ReactComponent };